import React from 'react';
import { useParams } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { Modal, Form } from 'antd';
import RemoveTenantFromRoomForm from './components/RemoveTenantFromRoomForm';
import useUntieTenantFromRoom from '../../../mutations/useUntieTenantFromRoomMutation';
import { facilityMetersKeys, roomQueryKeys } from '../../../queries/queryKeys';

const RemoveTenantFromRoom = ({
  form,
  onCancel,
  visible,
  initialValues,
  roomId,
}) => {
  const { resetFields, validateFieldsAndScroll } = form;

  const params = useParams();

  const queryClient = useQueryClient();

  const { mutateAsync: removeMutateAsync, isLoading: isRemoveLoading } =
    useUntieTenantFromRoom({
      onSuccess: () => {
        queryClient.invalidateQueries(roomQueryKeys(roomId));
        queryClient.invalidateQueries(
          facilityMetersKeys({
            facilityId: params.facilityId,
            officeId: roomId,
          })
        );
      },
    });

  const handleCancel = () => {
    resetFields();

    if (typeof onCancel === 'function') {
      onCancel();
    }
  };

  const handleSubmit = () => {
    validateFieldsAndScroll(async (err, fieldValues) => {
      if (!err) {
        const { endDate, ...otherValues } = fieldValues;

        const meterReadings = Object.entries(otherValues)
          .filter(([key]) => key.includes('reading'))
          .map(([_key, value]) => {
            value.reading = Number(value.reading.trim());

            return value;
          });

        const values = {
          officeId: roomId,
          tenantId: initialValues.id,
          endDate: endDate.utc().format(),
          meterReadings,
        };

        await removeMutateAsync({ values });

        handleCancel();
      }
    });
  };

  return (
    <Modal
      width={650}
      visible={visible}
      title="Прекращение предоставления услуг"
      onCancel={handleCancel}
      onOk={handleSubmit}
      okText="Завершить договор"
      confirmLoading={isRemoveLoading}
      destroyOnClose
    >
      <RemoveTenantFromRoomForm form={form} initialValues={initialValues} />
    </Modal>
  );
};

const RemoveTenantFromRoomModal = Form.create({
  name: 'remove_tenant_from_room',
})(RemoveTenantFromRoom);

export default RemoveTenantFromRoomModal;
